import { Permission } from '@hooks/usePermissions';
import { Button, Input, Typography, Select, Popconfirm, Drawer, Table } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { getColumnSearchProps, naturalSorter } from '@utils/filterandsort';
import { SubgrupoProduto } from '@models/Produto';
import { ProdutosControllerInterface } from '@controllers/controllers';

const { Text } = Typography;

function NovoSubGrupoForm({ controller }: { controller: ProdutosControllerInterface }) {
  const { data, actions } = controller();
  return (
    <Drawer
      title="Subgrupos de Produtos"
      width={400}
      closable={true}
      onClose={() => actions.NovoSubGrupo()}
      open={data.novosubgrupovisible}
    >
      <div>
        <Select
          style={{ marginBottom: 10, width: '90%' }}
          placeholder="Grupos"
          showSearch
          value={data.subgruposgrupoid}
          onChange={(value) => actions.SetSubGrupoGrupoID(value)}
          optionFilterProp="label"
        >
          {data.grupos.map((c, index) => (
            <Select.Option value={c.id} label={c.descricao} key={index}>
              {c.descricao}
            </Select.Option>
          ))}
        </Select>
        <hr />
        <Permission permission="produto.add">
          <Input.Group compact>
            <Input
              style={{ width: '90%' }}
              placeholder="Criar novo subgrupo"
              value={data.novogrupo}
              onChange={(e) => actions.NovoGrupoChange(e.target.value)}
            />
            <Button
              style={{ width: '10%' }}
              loading={data.addgrupoloading}
              onClick={() => actions.CriarSubgrupo()}
              icon={<PlusOutlined />}
            />
          </Input.Group>
        </Permission>
        <Permission permission="produto.list">
          <Table
            loading={data.excluirgrupoloading}
            rowKey="id"
            scroll={{ y: '70vh' }}
            size="small"
            pagination={false}
            dataSource={
              data.grupos.find((c) => c.id === data.subgruposgrupoid)
                ? data.grupos.find((c) => c.id === data.subgruposgrupoid)?.subgrupoProdutos
                : []
            }
          >
            <Table.Column
              title="Editar"
              width={60}
              render={(_, row: SubgrupoProduto) => (
                <Permission permission="produto.delete">
                  <Popconfirm
                    key="1"
                    title="Tem certeza que deseja remover o grupo?"
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={() => actions.ExcluirSubgrupo(row.id)}
                  >
                    <Button size="small" icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Permission>
              )}
            />
            <Table.Column
              title="Descrição"
              sorter={(a, b) => naturalSorter(a.descricao, b.descricao)}
              dataIndex="descricao"
              {...getColumnSearchProps('descricao', 'string', 'Descrição', undefined, undefined)}
              render={(text, row) => (
                <>
                  <Permission permission="produto.delete">
                    {row.codigo + ' - '}
                    <Text
                      editable={{
                        onChange: (value) => actions.EditarSubgrupo(row.id, value),
                      }}
                    >
                      {text}
                    </Text>
                  </Permission>
                </>
              )}
            />
          </Table>
        </Permission>
      </div>
    </Drawer>
  );
}

export default NovoSubGrupoForm;
